module.exports = __webpack_public_path__ + "img/BRCA4_CD8T.4c004de6.png";